/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import RelationshipCondition from 'cio/app-models/conditions/relationship';

interface ConditionListRelationshipEditorArgs {
  condition: RelationshipCondition;
  variation: string;
  subLayout: string;
  direction: string;
  size: string;
  marginClass?: string;
  hiddenInverseOptions?: string[];
}

export default class ConditionListRelationshipEditorComponent extends Component<ConditionListRelationshipEditorArgs> {
  @computed('condition.filters.[]')
  get hasFilters() {
    return this.args.condition.filters.length > 0;
  }

  get disabledInverseOptions() {
    return [];
  }
}
